// extracted by mini-css-extract-plugin
export default {"container":"Pdf_container__oL0WP"};